export default __webpack_public_path__ + "static/media/case.e1bfb248.jpeg";